<template>
  <el-dialog title="新增其他类采购单" :visible.sync="dialogTableVisible" width="55%">
    <el-row class="border-bottom padding">
      <el-col :span="24" class="line-height">采购说明</el-col>
      <el-col :span="12" class="line-height">
        <el-input
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4}"
          placeholder="请输入内容"
          v-model="Explain"
        ></el-input>
      </el-col>
        <el-col :span="19" class="line-height padding">
          <span>采购列表</span>
          <el-button style="margin-left:20px;" type="primary" @click="AddPurchaselist">新增采购</el-button>
        </el-col>
      <el-col :span="24">
        <el-table :data="Purchaselist" border style="width: 100%">
          <el-table-column label="名称">
            <template slot-scope="scope">
              <el-input v-model="scope.row.purchasedItemName"></el-input>
            </template>
          </el-table-column>
          <el-table-column  label="规格描述">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specificationModel"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="采购单价">
            <template slot-scope="scope">
              <el-input v-model="scope.row.purchasePrice"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="采购链接">
            <template slot-scope="scope">
              <el-input v-model="scope.row.purchaseLink"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="单位">
            <template slot-scope="scope">
              <el-input v-model="scope.row.unit"></el-input>
            </template>
          </el-table-column>
          <el-table-column  label="数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.quantity"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="运单号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.internalConveyNumber"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remarks"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="danger" @click="dele(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" class="line-height">
        <span>采购总计:</span>
        <el-input-number v-model="num" size="mini" :min="0" label="总计" style="margin-left:20px;"></el-input-number>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="dialogTableVisible = false">单据完结</el-button> -->
      <el-button type="primary" @click="complete">完成</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ajaxPost ,Baseurl} from '../../../api/api/api';
export default {
  name: "AddOtherprocurementedit",
  data() {
    return {
      dialogTableVisible: false,
      str:"",
      num:"",
      Explain: "",
      Purchaselist: [
        {
          ids: "0",
          purchasedItemName: "",
          specificationModel: "",
          purchasePrice: "",
          purchaseLink: "",
          unit:"",
          quantity: "",
          internalConveyNumber: "",
          remarks: ""
        }
      ],
    };
  },
  mounted() {},
  created() {
    this.str = JSON.parse(localStorage.getItem("role"));
  },
  methods: {
    init() {
      this.dialogTableVisible = true;
    },
    AddPurchaselist() {
      const param = {
        ids: this.Purchaselist.length,
        purchasedItemName: "",
        specificationModel: "",
        purchasePrice: "",
        purchaseLink: "",
        unit:"",
        quantity: "",
        internalConveyNumber: "",
        remarks: ""
      };
      this.Purchaselist.push(param);
    },
    dele(item) {
      if (this.Purchaselist.length > 1) {
        this.Purchaselist.splice(item.ids, 1);
        this.$message("删除成功");
      } else {
        this.$message("此采购列表必须最少保留1条");
      }
    },
    complete(){
      var obj = {
        companyId:this.str.company_id,
        purchaseRoleId:this.str.rid,
        purchaseTotalAmount:this.num,
        purchaseInstructions:this.Explain,
        generalProcurementList:this.Purchaselist
      }
      ajaxPost(Baseurl + "generalProcurementController/insertGeneralProcurement",obj).then(res => {
          if(res.data.code == 200){
              this.$message({
                  message: '新增其他类采购单成功',
                  type: 'success'
              });
              this.$emit("Add")
          }else(
              this.$message.error(res.data.data)
          )
          this.num = ""
          this.Explain = ""
          this.Purchaselist = [{
            ids: this.Purchaselist.length,
            purchasedItemName: "",
            specificationModel: "",
            purchasePrice: "",
            purchaseLink: "",
            unit:"",
            quantity: "",
            internalConveyNumber: "",
            remarks: ""
          }]
          this.dialogTableVisible = false
      })
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ {
  .el-dialog__body {
    padding: 13px 20px;
  }
}
.line-height {
  line-height: 35px;
  margin-top: 10px;
}
.padding {
  padding: 10px 0;
}
img {
  width: 100%;
  height: 100%;
}
</style>